module.exports = __webpack_public_path__ + "static/media/ford-search-sync.3a264691.png";